import {PixiObject} from "../primitives/pixi-object";
import {ImageDrawable} from "./image.pixi";
import {BlueprintContext} from "../../../world/cyanprints/i-blueprint-context";
import {Graphics} from "pixi.js";
import {DRect} from "../../../primitives/drawable-rect";
import {ImageProperties} from "../../../../state/entities/component-properties-dto/images.properties.dto";
import {Subject} from "rxjs";


export class ImageRow extends PixiObject {
    private imagesByFileId: { [key: string]: ImageDrawable } = {};
    private blueprintContext: BlueprintContext;

    activeImageId: Subject<string> = new Subject();
    imageProps: ImageProperties[] = [];
    background: Graphics;
    maxSquareSize: number;
    widthHeightSubject: Subject<{ width: number, height: number }> = new Subject();
    imageSelectedSubject: Subject<string> = new Subject();
    targetWidth: number;

    constructor(config?: {
        id?: string,
        maxSquareSize?: number,
        width: number,
        blueprintContext: BlueprintContext
    }) {
        super(config);
        this.targetWidth = config.width;
        this.maxSquareSize = config.maxSquareSize ?? 50;
        this.blueprintContext = config.blueprintContext;
        // this.buildBackground(this.width)
    }

    async setImages(imageProps: ImageProperties[]) {
        if (imageProps.length == 0) {
            console.log("No images in image row");
            return
        }
        this.imageProps = imageProps;
        const first = imageProps[0];
        this.activeImageId.next(first.fileId)
        this.destroyImages()
        this.createImages().catch(err => {
            console.log("Error creating images", err);
        })
    }

    destroyImages(

    ) {}

    async createImages() {
        let idCounter = 0
        for (const imageProp of this.imageProps) {
            this.imagesByFileId[imageProp.fileId] = new ImageDrawable({
                id: `imgr-${this.id}-${idCounter}`,
                fileId: imageProp.fileId,
                fitInSquareSize: this.maxSquareSize,
                borderRadius: 5,
                // debug: true,
                blueprintContext: this.blueprintContext
            })
            // this.imagesByFileId[imageProp.fileId].createOrUpdate({})
            this.imagesByFileId[imageProp.fileId].debug = true
            this.imagesByFileId[imageProp.fileId].widthHeightSubject.subscribe(dimensions => {
                // this.imagesByFileId[imageProp.fileId].updateTouchBounds()
                this.layout()
            })
            this.imagesByFileId[imageProp.fileId].touchPrimitive.showPointerCursor = true
            this.imagesByFileId[imageProp.fileId].touchPrimitive.onPressed( (pt) => {
                this.imageSelectedSubject.next(imageProp.fileId)
                return true
            })
            this.addChild(this.imagesByFileId[imageProp.fileId])
            idCounter += 1
        }
    }

    private layout() {
        let startX = 20
        let cursorX = startX;
        let cursorY = 10;
        let width = 0;
        let paddingX = 12
        let height = this.maxSquareSize;
        for (const imageKey of Object.keys(this.imagesByFileId)) {
            const image = this.imagesByFileId[imageKey];
            if (cursorX + image.sprite.width > this.targetWidth) {
                cursorX = startX;
                cursorY += this.maxSquareSize;
                height += this.maxSquareSize;
            }
            let yDiff = (this.maxSquareSize - image.sprite.height) / 2;
            image.x = cursorX;
            image.y = cursorY + yDiff;
            cursorX += image.sprite.width + paddingX;
        }
        width = this.sprite.width + 25
        height += 20
        this.buildBackground(width, height)
        this.updateTouchBounds()
    }

    override setupDefaultInteractions() {

    }


    buildBackground(width: number, height: number) {
        if (this.background) {
            this.background.destroy();
        }
        this.background = new Graphics({});
        const rect = new DRect({
            left: 0,
            top: 0,
            right: width,
            bottom: height,
            roundness: 100,
            colour: '#353535',
        });
        rect.render(this.background);
        this.sprite.addChildAt(this.background, 0);
    }

    fitInSquare(width, height) {
        const MAX_SIZE = this.maxSquareSize;
        const ratio = width > height
            ? MAX_SIZE / width
            : MAX_SIZE / height;
        return {
            width: Math.round(width * ratio),
            height: Math.round(height * ratio)
        };
    }

}